module.exports = __webpack_public_path__ + "img/usa.218f936f.png";